import Box from '@zenbusiness/zui/Box';
import Divider from '@zenbusiness/zui/Divider';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledPageWrapper = superstyled({
  name: 'SubscriptionCancelPageWrapper',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.grey[50],
    minHeight: '100vh'
  })
});

export const StyledFocusHeader = superstyled({
  name: 'SubscriptionCancelFocusHeader',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.grey[50]
  })
});

export const StyledContentContainer = superstyled({
  name: 'SubscriptionCancelContent',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: 600,
    margin: '0 auto',
    padding: theme.spacing(5, 3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  })
});

export const StyledSubscriptionCard = superstyled({
  name: 'SubscriptionCancelSubCard',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.fixed.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 24,
    boxShadow: '0px 1px 2px 0px rgba(15,22,28,0.04), 0px 1.5px 3px -0.5px rgba(15,22,28,0.08)',
    overflow: 'hidden'
  })
});

export const StyledCardRow = superstyled({
  name: 'SubscriptionCancelCardRow',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(2, 3)
  })
});

export const StyledCardDivider = superstyled({
  name: 'SubscriptionCancelCardDivider',
  slot: 'Root',
  tag: Divider,
  styles: ({ theme }) => ({
    marginInline: theme.spacing(3)
  })
});

export const StyledBenefitsBox = superstyled({
  name: 'SubscriptionCancelBenefits',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.orange.light,
    borderRadius: 24,
    padding: theme.spacing(3),
    overflow: 'hidden'
  })
});

export const StyledIconSquare = superstyled({
  name: 'SubscriptionCancelIconSquare',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    minWidth: 32,
    height: 32,
    borderRadius: 4,
    backgroundColor: theme.palette.background.orange.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })
});

export const StyledHelpRow = superstyled({
  name: 'SubscriptionCancelHelpRow',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
});

export const StyledSummaryCard = superstyled({
  name: 'SubscriptionCancelSummaryCard',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.fixed.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 24,
    boxShadow: '0px 1px 2px 0px rgba(15,22,28,0.04), 0px 1.5px 3px -0.5px rgba(15,22,28,0.08)',
    overflow: 'hidden',
    paddingBlock: theme.spacing(1.5)
  })
});

export const StyledSummaryRow = superstyled({
  name: 'SubscriptionCancelSummaryRow',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    paddingInline: theme.spacing(3),
    paddingBlock: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
});

export const StyledSummaryDivider = superstyled({
  name: 'SubscriptionCancelSummaryDivider',
  slot: 'Root',
  tag: Divider,
  styles: () => ({
    marginInline: 0
  })
});

export const StyledReasonSection = superstyled({
  name: 'SubscriptionCancelReasonSection',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5)
  })
});

export const StyledContinueButtonRow = superstyled({
  name: 'SubscriptionCancelContinueRow',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      '& > *': {
        width: '100%'
      }
    }
  })
});
